/**
 * Home Page Sections Configuration
 * 
 * Defines the structure and order of all homepage sections.
 * Each section is rendered sequentially with automatic spacing.
 * 
 * ARCHITECTURE:
 * - Navigation: Fixed header components (Navbar)
 * - Hero: Full-screen landing section
 * - Content: Main page sections (Services, Values, Contact)
 * - Footer: Bottom site information
 * 
 * SPACING STRATEGY:
 * - All content sections use py-20 for consistent vertical rhythm
 * - Hero has custom viewport-based sizing (h-screen)
 * - Navbar is fixed/sticky positioned
 * - No manual separators needed (sections flow naturally)
 * 
 * @module config/homeSections
 */

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import GetInTouch from "@/components/GetInTouch";
import Values from "@/components/Values";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { PageSection } from "@/types/sections";

/**
 * Homepage sections in render order
 * 
 * Categories:
 * - navigation: Top-level navigation elements
 * - hero: Main landing/hero section
 * - content: Core page content sections
 * - footer: Bottom site information
 */
export const homeSections: PageSection[] = [
  {
    id: 'navbar',
    component: Navbar,
    category: 'navigation',
  },
  {
    id: 'hero',
    component: Hero,
    category: 'hero',
  },
  {
    id: 'services',
    component: Services,
    category: 'content',
  },
  {
    id: 'get-in-touch',
    component: GetInTouch,
    category: 'content',
  },
  {
    id: 'values',
    component: Values,
    category: 'content',
  },
  {
    id: 'contact',
    component: Contact,
    category: 'content',
  },
  {
    id: 'footer',
    component: Footer,
    category: 'footer',
  },
];
